export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ??
  (import.meta.env.PROD
    ? "https://api.claudafinil.app"
    : "http://localhost:8787");

export const SITE_BASE_URL =
  import.meta.env.VITE_SITE_BASE_URL ??
  (import.meta.env.PROD ? "https://claudafinil.app" : "http://localhost:4321");

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? "";
